import React, { useState, useEffect } from "react";
import Header from "src/Containers/Header"; 
import portimg1 from "../../assets/PortHolidaySchedule/1.jpg";
import portimg2 from "../../assets/PortHolidaySchedule/2.jpg";
import portimg3 from "../../assets/PortHolidaySchedule/3.jpeg"; 
import "./Aboutus.css";
import { Link } from "react-router-dom";
import { languageJson } from "../../StringVariable";
import * as firebase from "firebase/app";
import { getAnalytics, logEvent } from "firebase/analytics";
import { firebaseConfig } from "src/firebaseConfig";
import MarineTerminalCalendar from "../Vessel_Operations/MarineTerminalCalendar";
import axios from "src/redux/actions/apis";
import { GET_HOLIDAYS_FOR_PUBLIC } from "../../url/Url";
import SpinerLoader from "src/utils/SpinerLoader";
const app = firebase.initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

function PortSecurityandSafety() {
  const [holidaysData, setHolidaysData] = useState(null);
  const [loadData, setloadData] = useState(null)

  useEffect(() => {
    logEvent(analytics, "Port Holiday Calendar");
  }, []);
   const getHolidayCalendar = async () => {
    const requestObj = {
      headers: {
        "Content-Type": "application/xml",
      },
    };
    try {
      const res = await axios.get(GET_HOLIDAYS_FOR_PUBLIC, requestObj);
      const { data, customcode } = res.data;
      if (customcode === 200 && Object.keys(data).length > 0) {
        setHolidaysData(data);
        setloadData(true)
      } else {
        setHolidaysData([]);
        setloadData(true)
      }
    } catch (err) {
      console.log(err);
      setloadData(true)
    }
  };

  useEffect(() => {
    getHolidayCalendar();
  }, []);
 
  return (
    <>
      <Header />
      <div className="image-row-banner">
        <img className="banner_img" src={portimg1} alt="Banner 1"/>
        <img className="banner_img" src={portimg3} alt="Banner 2"/>
        <img className="banner_img" src={portimg2} alt="Banner 3"/>
      </div>
      <div className="vo-bg">
        <div className="container-fluid row py-4">
          <div>
            <Link to="/">
              <span className="vo-menu pe-2">{languageJson.home_txt}</span>
            </Link>
            <span className="text-dark ps-2"> / &nbsp; {languageJson.port_holiday_calendar}</span>
          </div>
        </div>
      </div>
      <div className="railCrossinglRoutesMainDiv">
        <section className="railcrossing-head container">
          <div className="row container-fluid py-5 tabVesselDiv">
          <div className="truckTurnTimeMainDiv historicalTTTMainDiv">
            <div className="container">
          <div className="titleDescpDiv">
            <h2>{languageJson.port_holiday_calendar}</h2>
          </div>
          </div>
          </div>
            <div >
              <div>
              
                <div className="container" >
                {loadData ? 
                <>{holidaysData && (
            <span>
              {" "}
              <MarineTerminalCalendar data={holidaysData}/>{" "}
            </span>
          )}</>:<SpinerLoader />
                  
          
          }
                </div>
                </div>
                </div>
        
                </div>
                </section>
                </div>
                
    </>
  );
}

export default PortSecurityandSafety;
